import { notificationConstants } from '../_constants';
import * as commonAction from './commonAction';
import { commonService } from '../_services';
import { alertActions } from './';

export const notificationActions = {
    addNotification,
    getNotificationsList,
    //addUpdateNotification,
    sentPushNotifications,
    deleteNotifications,
    getUserNotificationsList,
    getUserNotificationsForBell,
    sendNotifications,
    sentEmailNotifications,
    //updateNotificationStatus,
};

//-- insert addNotification
function addNotification(apiName, notificationData, getApi, postData) {
    return dispatch => {
        dispatch(
            commonAction.request(notificationConstants.NOTIFICATION_ADDED_REQUEST, notificationData)
        );
        commonService.withToken(apiName, notificationData).then(
            notification => {
                dispatch(commonAction.success(notificationConstants.NOTIFICATION_ADDED_SUCCESS, notification));
                dispatch(alertActions.success("Notification Added Successfully"));
                setTimeout(function () {
                    dispatch(alertActions.clear());
                }, 3000);

                dispatch(getNotificationsList(getApi, postData));
            },
            error => {
                dispatch(
                    commonAction.failure(notificationConstants.NOTIFICATION_ADDED_FAILURE, error)
                );
                dispatch(alertActions.error(error.response.data.error));
            }
        );
    };
}

//-- getNotificationsList
function getNotificationsList(apiName, notificationData) {

    return dispatch => {

        dispatch(
            commonAction.request(notificationConstants.NOTIFICATION_LIST_REQUEST, notificationData)
        );
        commonService.withTokenPut(apiName, notificationData).then(
            notification => {

                dispatch(
                    commonAction.success(notificationConstants.NOTIFICATION_LIST_SUCCESS, notification)
                );
            },
            error => {
                dispatch(
                    commonAction.failure(notificationConstants.NOTIFICATION_LIST_ERROR, error)
                );
                dispatch(alertActions.error(error.response.data.error));
            }
        );
    };
}


//-- add/Update Notifications data
// function addUpdateNotification(apiName, notificationData, apiNameListing, postDataForListing) {
//     return dispatch => {
//         dispatch(commonAction.request(notificationConstants.NOTIFICATION_LIST_REQUEST, notificationData));
//         commonService.withToken(apiName, notificationData)
//             .then(
//                 notification => {
//                     setTimeout(function () {
//                         dispatch(getNotificationsList(apiNameListing, postDataForListing));
//                     }, 1000);

//                     dispatch(commonAction.success(notificationConstants.NOTIFICATION_LIST_SUCCESS, notification));
//                     dispatch(alertActions.success(notification.data.message));
//                     if (notification.success == false) {
//                         dispatch(commonAction.failure(notificationConstants.NOTIFICATION_LIST_ERROR, notification.message));
//                         dispatch(alertActions.error(notification.message));
//                     }
//                     setTimeout(function () {
//                         dispatch(alertActions.clear())
//                     }, 3000);
//                 },
//                 error => {
//                     dispatch(alertActions.error(error.response.data.error));
//                 }
//             );
//     };
// }

//-- Sent Push Notifications
function sentPushNotifications(apiName, data) {
    return dispatch => {
        dispatch(commonAction.request(notificationConstants.SENT_NOTIFICATION_LIST_REQUEST, data));
        commonService.withToken(apiName, data)
            .then(
                notification => {
                  if(notification.data.error !== undefined && notification.data.error.msg !== undefined){ dispatch(alertActions.error(notification.data.error.msg)); }
                  dispatch(commonAction.success(notificationConstants.SENT_NOTIFICATION_LIST_SUCCESS, notification));
                  if(notification.data !== undefined && notification.data.msg !== undefined){ dispatch(alertActions.success(notification.data.msg)); }

                    setTimeout(function () {
                        dispatch(alertActions.clear())
                    }, 3000);
                },
                error => {
                    console.log("Action error--", error);
                    dispatch(
                        commonAction.failure(notificationConstants.SENT_NOTIFICATION_LIST_ERROR, error)
                    );
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}

//-- Delete Notifications
function deleteNotifications(apiName, notificationData, apiNameListing, postDataForListing) {
    return dispatch => {
        dispatch(commonAction.request(notificationConstants.NOTIFICATION_LIST_REQUEST, notificationData));
        commonService.withToken(apiName, notificationData)
            .then(
                notification => {
                    setTimeout(function () {
                        dispatch(getNotificationsList(apiNameListing, postDataForListing));
                    }, 1000);

                    dispatch(commonAction.success(notificationConstants.NOTIFICATION_LIST_SUCCESS, notification));
                    dispatch(alertActions.success(notification.data.message));
                    if (notification.success == false) {
                        dispatch(commonAction.failure(notificationConstants.NOTIFICATION_LIST_ERROR, notification.message));
                        dispatch(alertActions.error(notification.message));
                    }
                    setTimeout(function () {
                        dispatch(alertActions.clear())
                    }, 3000);
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}


//-- get users notifications
function getUserNotificationsList(apiName, notificationData) {

    return dispatch => {

        dispatch(
            commonAction.request(notificationConstants.USERS_NOTIFICATION_LIST_REQUEST, notificationData)
        );
        commonService.withTokenPut(apiName, notificationData).then(
            notification => {

                dispatch(
                    commonAction.success(notificationConstants.USERS_NOTIFICATION_LIST_SUCCESS, notification)
                );
            },
            error => {
                dispatch(
                    commonAction.failure(notificationConstants.USERS_NOTIFICATION_LIST_ERROR,error)
                );
                dispatch(alertActions.error(error.response.data.error));
            }
        );
    };
}

//-- get users notifications for bell icon
function getUserNotificationsForBell(apiName, notificationData) {

    return dispatch => {

        dispatch(
            commonAction.request(notificationConstants.USERS_BELL_NOTIFICATION_LIST_REQUEST, notificationData)
        );
        commonService.withTokenPut(apiName, notificationData).then(
            notification => {

                dispatch(
                    commonAction.success(notificationConstants.USERS_BELL_NOTIFICATION_LIST_SUCCESS, notification)
                );
            },
            error => {
                dispatch(
                    commonAction.failure(notificationConstants.USERS_BELL_NOTIFICATION_LIST_ERROR, error)
                );
                dispatch(alertActions.error(error.response.data.error));
            }
        );
    };
}

//-- Sent notifications
function sendNotifications(apiName, sendNoticesData, apiNameListing, postDataForListing) {
    return dispatch => {
        dispatch(commonAction.request(notificationConstants.NOTIFICATION_LIST_REQUEST, sendNoticesData));
        commonService.withToken(apiName, sendNoticesData)
            .then(
                term => {
                    setTimeout(function () {
                        dispatch(getNotificationsList(apiNameListing, postDataForListing));
                    }, 1000);

                    dispatch(commonAction.success(notificationConstants.NOTIFICATION_LIST_SUCCESS, term));
                    dispatch(alertActions.success("Notification sent to all the Users"));
                    if (term.success == false) {
                        dispatch(commonAction.failure(notificationConstants.NOTIFICATION_LIST_ERROR, term.message));
                        dispatch(alertActions.error(term.message));
                    }
                    setTimeout(function () {
                        dispatch(alertActions.clear())
                    }, 3000);
                },
                error => {
                    dispatch(alertActions.error(error.response.data.error));
                }
            );
    };
}

//-- Sent Email Notifications
function sentEmailNotifications(apiName, data) {
    return dispatch => {
        dispatch(commonAction.request(notificationConstants.SENT_NOTIFICATION_LIST_REQUEST, data));
        commonService.withToken(apiName, data)
            .then(
                notification => {
                    dispatch(commonAction.success(notificationConstants.SENT_NOTIFICATION_LIST_SUCCESS, notification));
                    dispatch(alertActions.success(notification.data.message));
                    setTimeout(function () {
                        dispatch(alertActions.clear())
                    }, 3000);
                },
                error => {                 
                    dispatch(alertActions.error("Error while processing the request!!"));
                    setTimeout(function () {
                        dispatch(alertActions.clear())
                    }, 3000);
                }
            );
    };
}

//-- Update Notification status, admin can chagnge the status of any Notification
// function updateNotificationStatus(apiName, notificationData) {
//     return dispatch => {
//         dispatch(commonAction.request(notificationConstants.NOTIFICATION_UPDATE_STATUS_REQUEST, notificationData));
//         commonService.withToken(apiName, notificationData)
//             .then(
//                 notification => {
//                     dispatch(commonAction.success(notificationConstants.NOTIFICATION_UPDATE_STATUS_SUCCESS, notification));
//                     dispatch(alertActions.success(notification.data.message));
//                     setTimeout(function () {
//                         dispatch(alertActions.clear())
//                     }, 3000);
//                 },
//                 error => {
//                     dispatch(alertActions.error(error.response.data.error));
//                 }
//             );
//     };
// }
